import axios from "axios";

export const API = "/api";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tj_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function photoUrl(photoId) {
  const token = localStorage.getItem("tj_token");
  return `${API}/photos/${photoId}${token ? `?auth=${token}` : ""}`;
}

export function errDetail(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}
